// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "20261013.1791920948/static/js/" + chunkId + "." + {"249":"2ffb103c","463":"8a875d0b"}[chunkId] + ".chunk.js";
};